import React from 'react';

type Props = {
  name: string;
  onClick?: () => void;
  className?: string;
};

function AiIcon({ name, onClick, className = '' }: Props) {
  return (
    <em
      className={`ant-icon ai-icon ai-icon-${name} ${
        onClick ? 'clicked' : ''
      } ${className}`}
      onClick={onClick}
    />
  );
}

export default AiIcon;
